import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AdminTabType } from './types';
import {
  Container,
  Header,
  Title,
  Description,
  TabContainer,
  TabContent,
  ContentArea
} from './components/styled';
import AdminTabNavigation from './components/AdminTabNavigation';
import CreditsTab from './components/CreditsTab';
import ManageUsersTab from './components/ManageUsersTab';

const AdminPanelPage: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<AdminTabType>('credits');
  
  // Handle URL tab parameter
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab') as AdminTabType;
    if (tabParam && ['credits', 'users'].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location.search]);
  const renderTabContent = () => {
    switch (activeTab) {
      case 'credits':
        return <CreditsTab />;
      case 'users':
        return <ManageUsersTab />;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Header>
        <Title>⚙️ Admin Panel</Title>
        <Description>
          Manage your credits and team members. Monitor your credit usage and balance,
          and manage user access and permissions for your organization.
        </Description>
      </Header>
      
      <TabContainer>
        <AdminTabNavigation
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        
        <TabContent>
          <ContentArea>
            {renderTabContent()}
          </ContentArea>
        </TabContent>
      </TabContainer>
    </Container>
  );
};

export default AdminPanelPage;
